import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";

import './index.css'
import App from './App.jsx'
document.documentElement.classList.remove('dark');
document.documentElement.classList.add('light');

Sentry.init({
  dsn: "https://343edb030673d929e60f1ecd5d06d357@o4505865414574080.ingest.us.sentry.io/4509161659039744",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
